var _templateObject, _templateObject2;

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import { css } from "styled-components";
import { map } from "../../breakpoint";
import { getSpacingFromTheme } from "../../spacing/core";
export function getSpacingValues(values) {
  return function (_ref) {
    var theme = _ref.theme;
    return getSpacingFromTheme(values, theme);
  };
}
export var gap = function gap(props) {
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n"])), function (_ref2) {
    var gap = _ref2.gap;
    return map(gap, function (val) {
      return val != undefined && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n          gap: ", ";\n        "])), getSpacingValues(val));
    });
  });
};